import { useTestStore, TV_TESTS, MOBILE_TESTS } from '@/store/useTestStore';
import { Layout } from '@/components/Layout';
import { Overview } from '@/pages/Overview';
import { TvTestSuite } from '@/pages/TvTestSuite';
import { MobileTestSuite } from '@/pages/MobileTestSuite';
import { Summary } from '@/pages/Summary';

function AppContent() {
  const { activeView, deviceMode } = useTestStore();

  if (activeView === 'overview') return <Overview />;
  if (activeView === 'summary') return <Summary />;

  // TV tests
  if (deviceMode === 'tv' && (TV_TESTS as readonly string[]).includes(activeView)) {
    return <TvTestSuite />;
  }

  // Mobile tests
  if (deviceMode === 'mobile' && (MOBILE_TESTS as readonly string[]).includes(activeView)) {
    return <MobileTestSuite />;
  }

  return <Overview />;
}

export default function App() {
  return (
    <Layout>
      <AppContent />
    </Layout>
  );
}
